import React from 'react';
import classNames from 'classnames';

import {Badge} from 'reactstrap';
import {startCase} from 'lodash';
import {STATUS_LABELS, STATUS_TYPES} from 'configs';

import styles from './styles.module.scss';

const DEFAULT_COLORS = {
  [STATUS_TYPES.active]: 'success',
  [STATUS_TYPES.suspended]: 'suspended',
  [STATUS_TYPES.cbwithdrawn]: 'cb-withdrawn',
  [STATUS_TYPES.withdrawn]: 'withdrawn',
  [STATUS_TYPES.expired]: 'expired', // eol

  [STATUS_TYPES.inactive]: 'inactive',
  [STATUS_TYPES.cancelled]: 'cancelled',
  [STATUS_TYPES.pending]: 'pending',
  [STATUS_TYPES.hidden]: 'hidden',
  [STATUS_TYPES.deleted]: 'deleted',
  [STATUS_TYPES.error]: 'error',
  [STATUS_TYPES.invalid]: 'secondary',
};

const defaultProps = {
  labels: STATUS_LABELS,
};

function StatusBadge(props) {
  const {large, tooltip, status, colors, labels, className, ...rest} = props;

  return React.createElement(
    Badge,
    {
      color: colors ? colors[status] : null,
      className: classNames(className, {
        [styles['status-badge']]: !colors,
        [styles[`status-badge--${DEFAULT_COLORS[status]}`]]: !colors,
        [styles['status-badge--large']]: large,
      }),
      ...rest,
    },
    labels ? labels[status] : startCase(status)
  );
}

StatusBadge.defaultProps = defaultProps;

export default StatusBadge;
